import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-rolling-commission',
  templateUrl: './rolling-commission.component.html',
  styleUrls: ['./rolling-commission.component.scss'],
})
export class RollingCommissionComponent implements OnInit {
  title = 'app-rolling-commission';

  ngOnInit(): void {}
}
